import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCamera1"><Path fillRule="evenodd" clipRule="evenodd" d="M6.96482 6L8.96482 3H15.0352L17.0352 6H22V21H2V6H6.96482ZM12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera1;
